module.exports = __webpack_public_path__ + "media/images/login/VenuTRAX-WH-2s-21a6199dd23f6545f1a830ee15eaf155.png";